import {connect} from "react-redux";
import * as React from "react";
import Timer from "components/Layout/Timer/Timer.Component";
import {RootState} from "Redux/Reducers/_RootReducer";
import * as VehiclesModule from "Modules/VehiclesModule";

const TEN_SECONDS = 10

interface IMapTimerManager {
  refetchSearching: () => void
  shouldBeVisible: boolean
}

const MapTimerManager = ({
  refetchSearching,
  shouldBeVisible
}: IMapTimerManager) => shouldBeVisible ? (
  <Timer
    className="map-manage__timer"
    duration={TEN_SECONDS}
    onTimeEnds={refetchSearching}
  />
) : null

function mapStateToProps(state: RootState) {
  return {
    shouldBeVisible:
      !!state.vehiclesStore.queryParams
      && !state.vehiclesStore.hasRqError
      && state.vehiclesStore.vehiclesListFiltered.results.some?.(({ latestDataframe }) => latestDataframe)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    refetchSearching: () => dispatch(VehiclesModule.Actions.search(undefined, undefined, true))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MapTimerManager)



// WEBPACK FOOTER //
// ./src/components/Map/MapHelpers/MapTimer.Manager.tsx